document.addEventListener('DOMContentLoaded', () => {
    const wishlistCountElement = document.getElementById('wishlist-count');
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

    // Function to update the wishlist button text, icon, and trigger animation
    function updateWishlistButtonState(button, isAdded) {
        const wishlistText = button.querySelector('#wishlist-button-text');
        const wishlistIcon = button.querySelector('svg path');
        if (wishlistText) wishlistText.textContent = isAdded ? 'REMOVE FROM WISHLIST' : 'ADD TO WISHLIST';
        if (wishlistIcon) wishlistIcon.setAttribute('fill', isAdded ? '#ff3765' : 'none');

        button.classList.add('animate');
        button.addEventListener('animationend', () => {
            button.classList.remove('animate');
        }, { once: true });
    }

    // Function to update wishlist count
    function updateWishlistCount() {
        const count = wishlist.length;
        if (wishlistCountElement) {
            wishlistCountElement.textContent = count;
            wishlistCountElement.style.display = count > 0 ? 'inline-block' : 'none';
        }
    }

    // Function to track GA4 events with detailed item data
    function trackGA4Event(eventName, eventParams) {
        if (window.gtag) {
            gtag('event', eventName, eventParams);
        } else {
            console.warn(`GA4 not available: Event ${eventName} was not tracked.`);
        }
    }

    // Event delegation for handling clicks on wishlist buttons
    document.body.addEventListener('click', (event) => {
        const button = event.target.closest('[data-product-handle]');
        if (!button) return;

        event.preventDefault();
        const productHandle = button.dataset.productHandle;
        const productName = button.dataset.productName;
        const productId = button.dataset.productId;
        const productPrice = button.dataset.productPrice;
        const productBrand = button.dataset.productBrand || 'CANVAEGYPT'; // Add product brand
        const productCategory = button.dataset.productCategory || 'Clutches'; // Add product category
        const isAdded = wishlist.includes(productHandle);

        // Prepare the item data
        const itemData = {
            item_id: productId,
            item_name: productName,
            item_brand: productBrand,
            item_category: productCategory,
            price: productPrice,
        };

        // Ensure all necessary fields are available and log any missing fields
        if (!productId || !productName || !productPrice) {
            console.warn('Missing product data:', { productId, productName, productPrice });
            alert('This product has missing data and cannot be added to your wishlist.');
            return;
        }

        // Toggle wishlist state
        if (!isAdded) {
            wishlist.push(productHandle);  // Add product handle to wishlist
            trackGA4Event('add_to_wishlist', {
                items: [itemData],
                currency: 'EGP',
                event_category: 'engagement',
                event_label: 'Added to Wishlist',
            });
        } else {
            wishlist = wishlist.filter(handle => handle !== productHandle);  // Remove product handle from wishlist
            trackGA4Event('remove_from_wishlist', {
                items: [itemData],
                currency: 'EGP',
                event_category: 'engagement',
                event_label: 'Removed from Wishlist',
            });
        }

        // Save updated wishlist to localStorage
        localStorage.setItem('wishlist', JSON.stringify(wishlist));

        // Update button state and wishlist count
        updateWishlistButtonState(button, !isAdded);
        updateWishlistCount();
    });

    // Initialize button states for all wishlist buttons
    function initializeWishlistButtons() {
        document.querySelectorAll('[data-product-handle]').forEach(button => {
            const productHandle = button.dataset.productHandle;
            updateWishlistButtonState(button, wishlist.includes(productHandle));
        });
    }

    // Function to display wishlist items in the container
    function displayWishlistItems(container) {
        if (wishlist.length === 0) {
            container.innerHTML = '<p>Your wishlist is currently empty.</p>';
            return;
        }

        const productPromises = wishlist.map(handle => 
            fetch(`/products/${handle}.js`)
                .then(response => response.json())
                .then(product => 
                    `<div class="wishlist-item">
                        <a href="/products/${product.handle}">
                            <img src="${product.images[0]}" alt="${product.title}" />
                            <p>${product.title}</p>
                            <p>${(product.variants[0].price / 100).toFixed(2)} EGP</p>
                        </a>
                        <button onclick="removeFromWishlist('${handle}')" class="remove-wishlist-btn" aria-label="Remove ${product.title} from wishlist">Remove from Wishlist</button>
                        <button onclick="moveToCart('${product.variants[0].id}')" class="move-to-cart-btn" data-variant-id="${product.variants[0].id}">Move to Cart</button>
                    </div>`
                )
                .catch(() => `<p>Error loading product with handle ${handle}. Please try again later.</p>`)
        );

        Promise.all(productPromises)
            .then(items => {
                container.innerHTML = items.join('');
            })
            .catch(error => {
                console.error('Error loading wishlist items:', error);
            });
    }

    // Function to remove an item from wishlist without reloading the page
    window.removeFromWishlist = (productHandle) => {
        wishlist = wishlist.filter(handle => handle !== productHandle);
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
        updateWishlistCount();
        const wishlistContainer = document.getElementById('wishlist-items');
        if (wishlistContainer) {
            displayWishlistItems(wishlistContainer); // Re-render items without reloading
        }
    };

    // Debounced function to prevent multiple cart submissions
    let cartAdding = false;
    window.moveToCart = (variantId) => {
        if (cartAdding) return;  // Prevent multiple clicks
        cartAdding = true;

        const button = document.querySelector(`button[data-variant-id="${variantId}"]`);
        button.disabled = true; 
        button.textContent = 'Adding...';

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(() => {
            button.textContent = 'Added to Cart'; 
            openCartDrawer(); // Open cart drawer
        })
        .catch(error => {
            console.error('Error adding item to cart:', error);
            button.textContent = 'Move to Cart'; 
            button.disabled = false;
        })
        .finally(() => {
            cartAdding = false;
        });
    };

    // Initialize wishlist buttons and wishlist count
    initializeWishlistButtons();
    updateWishlistCount();

    // Display wishlist items if container is present
    const wishlistContainer = document.getElementById('wishlist-items');
    if (wishlistContainer) {
        displayWishlistItems(wishlistContainer);

        // Track GA4 view wishlist page event
        trackGA4Event('view_wishlist_page', {
            event_category: 'engagement',
            event_label: 'Wishlist Page Viewed',
        });
    }

    // Track GA4 share wishlist event when share button is clicked
    const shareWishlistBtn = document.getElementById('share-wishlist-btn');
    if (shareWishlistBtn) {
        shareWishlistBtn.addEventListener('click', () => {
            trackGA4Event('share_wishlist', {
                event_category: 'engagement',
                event_label: 'Wishlist Shared',
            });
        });
    }
});
